import { Link } from '@bridebook/web/app-shared/components/link/link';

interface IProps {
  url: string;
  title: string;
}

const TrackLink = ({ url, title }: IProps) => (
  <Link href={`/${url}`} className="bctrack">
    {title}
  </Link>
);

export default TrackLink;
